import { IOption } from 'types/common'
import { AuthRoleIdEnum } from 'constants/user'
import { IGroupMemberPermissionId } from 'interfaces/group'
import { IUserWithRelations } from 'interfaces/user'
import { getFullName } from 'utils/users'
import { getRoleName, roleOptions } from './components/RoleSelectionSection/constants'

export type IGroupOption = IOption<number> & { admin?: boolean; permissionId?: IGroupMemberPermissionId }

export function getDefaultValues(
  userDetail: IUserWithRelations,
  groupOptions: IGroupOption[],
  overrideRoleId?: number
) {
  const authRoleId: AuthRoleIdEnum = (overrideRoleId ?? userDetail?.authRoleId ?? AuthRoleIdEnum.PLAYER) as AuthRoleIdEnum
  const groupPermissions = Array.isArray(userDetail?.groupMembers)
    ? (userDetail.groupMembers
        .map(groupMember => {
          const foundOption = groupOptions.find(option => option.value === groupMember.groupId)
          return foundOption
            ? { ...foundOption, admin: groupMember.admin, permissionId: groupMember?.permissionId }
            : null
        })
        .filter(Boolean) as (IOption<number> & { admin: boolean })[])
    : []
  return {
    fullName: getFullName(userDetail?.firstName, userDetail.lastName) ?? '',
    username: userDetail?.username ?? '',
    email: userDetail?.email ?? '',
    authRoleId: roleOptions[authRoleId > 0 ? authRoleId - 1 : 0],
    image: userDetail?.image ?? '',
    role: getRoleName(authRoleId),
    groupPermissions
  }
}
